export function addAccessibilityToElem (e, ariaLabel) {
  // Set the tabIndex and arialLabel if available
  e.tabIndex = 0;
  if (ariaLabel) {
    e.ariaLabel = ariaLabel;
  }
}
